import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { SharedStorageKeyEnum } from 'src/app/shared/_config/storage/shared-storage-key-enum';
import { navHmeUrl } from 'src/app/shared/routing/routing.const';
import { valuePairToValue } from '@softpak/components/spx-helpers';
import { SpxStorage } from '@softpak/components/spx-storage';

@Injectable({
  providedIn: 'root'
})
export class SharedDepotSelectionGuard {
  router = inject(Router);


  canActivate(): boolean {
    const selection = valuePairToValue(SpxStorage.getChannelSetting<SharedStorageKeyEnum>(SharedStorageKeyEnum.depot));
    if (!selection) {
      this.router.navigate([navHmeUrl]);
      return false;
    }
    return true;
  }
}
